<template>
  <div>
    <div class="px-5 py-2">
      <div class="row">
        <div class="btn-home col-md-12 mt-3 mb-4 d-flex justify-content-end">
          <button type="button" class="btn btn-outline-main" @click="returnHome">
            <i class="fas fa-home-lg-alt"></i> Inicio
          </button>
        </div>
      </div>
      <div id="div-modal-cxc" class="d-flex justify-content-center">
        <div id="div-cxc" class="card w-100">
          <div class="card-header text-white h5 text-center" style="background: #900052">
            <strong>HISTORIAL DE MOV. ENTRE ALMACENES</strong>
          </div>
          <div class="card-body w-100">
            <div class="row">
              <div class="col-md-12 py-2 px-4">
                <div class="row d-flex">
                  <!--Fecha Filtro -->
                  <div class="px-1 mb-2" 
                      :class="dateFilter ? 'col-xl-2 col-lg-4 col-md-4 col-sm-4 col-xs-6' : 
                      'col-xl-2 col-lg-3 col-md-12 col-sm-12 col-xs-12'"
                  >
                    <div class="form-check form-switch">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckChecked"
                        v-model="dateFilter"
                        aria-checked="false"
                        @input="handleSwitchChange"
                      />
                      <label class="form-check-label" for="flexSwitchCheckChecked">
                        <strong style="font-size:13px">FILTRADO POR FECHAS</strong>
                      </label>
                    </div>
                  </div>
                  <template v-if="dateFilter">
                    <div class="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-xs-4 px-1 mb-2">
                        <div class="input-group input-group-sm w-100">
                          <span class="input-group-text">Desde</span>
                          <input
                            type="date"
                            @input="mtdGetData()"
                            aria-label="shift_date"
                            class="form-control form-control-sm"
                            id="init"
                            v-model="filter.init"
                          />
                        </div>
                    </div>
                    <div class="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-xs-4 px-1 mb-2">
                        <div class="input-group input-group-sm w-100">
                          <span class="input-group-text">Hasta</span>
                          <input
                            @input="mtdGetData()"
                            type="date"
                            aria-label="shift_date"
                            class="form-control form-control-sm"
                            id="end"
                            v-model="filter.end"
                          />
                        </div>
                    </div>
                  </template>
                  <!--Almacen Filtro -->
                  <div class="px-1 mb-2" 
                      :class="dateFilter ? 'col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-6' : 
                      'col-xl-5 col-lg-5 col-md-6 col-sm-6 col-xs-6'"
                  >
                      <v-select
                          class="text-dark flex-grow-1"
                          v-model="filter.almaOrigen"
                          label="name"
                          :options="dataAlmacenes"
                          placeholder="Seleccionar Alm. de Origen"
                          :reduce="(almacen) => almacen.id"
                          required
                          :clearable="false"
                          @input="mtdGetData()"
                      >
                          <template slot="no-options">
                          No hay Alm. para la búsqueda.
                          </template>
                      </v-select>
                  </div>
                  <div class="px-1 mb-2" 
                      :class="dateFilter ? 'col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-6' : 
                      'col-xl-5 col-lg-4 col-md-6 col-sm-6 col-xs-6'"
                  >
                      <v-select
                          class="text-dark flex-grow-1"
                          v-model="filter.almaDestino"
                          label="name"
                          :options="dataDestino"
                          placeholder="Seleccionar Alm. de Destino"
                          :reduce="(almacen) => almacen.id"
                          required
                          :clearable="false"
                          @input="mtdGetData()"
                      >
                          <template slot="no-options">
                          No hay Almacenes para la búsqueda.
                          </template>
                      </v-select>
                  </div>
                </div>
              </div>
              <!--Fin Filtro-->

              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2 mb-4 table-container"
                v-if="showTable"
              >
                <table
                  id="tb-anular"
                  class="table table-bordered border-main mb-0 px-0 text-xs"
                >
                  <thead>
                    <tr
                      class="text-white border-white text-center"
                      style="background: #900052; vertical-align: middle"
                    >
                      <th scope="col">DOCUMENTO</th>
                      <th scope="col">FECHA</th>
                      <th scope="col">ALMACEN ORIGEN</th>
                      <th scope="col">ALMACEN DESTINO</th>
                      <th scope="col">OBSERVACIÓN</th>
                      <th scope="col" class="table-th-acciones">ESTADO</th>
                      <th scope="col" class="table-th-acciones">ACCIONES</th>
                    </tr>
                  </thead>

                  <tbody class="custom-table">
                    <tr v-if="cpData.length == 0">
                      <td class="text-center align-middle" colspan="7">Sin Registros</td>
                    </tr>
                    
                    <tr class="text-center" style="vertical-align: middle" v-for="(item, index) in cpData" :key="index">
                        <td><strong>{{ item.correlative }}</strong></td>
                        <td>{{ item.date | formatDate }}</td>
                        <td>{{ item.almacenOrigen ? item.almacenOrigen : "-"  }}</td>
                        <td>{{ item.almacenDestino ? item.almacenDestino : "-"  }}</td>
                        <td class="observation-column" style="font-size: 10px">{{ item.observation ? item.observation : '-' }}</td>
                        <td>
                          <span :style="badgeStyle(item.anulation_state)">
                            {{ stateAnnular(item.anulation_state) }}
                          </span>
                        </td>
                        <td class="text-nowrap"> 
                          <div class="d-flex d-md-block justify-content-center">
                            <button 
                                @click="viewDetail(item, item.details)" class="btn btn-primary btn-sm rounded-circle bootom me-1" title="Detalle Mov.">
                                <i class="fa fa-eye"></i>
                            </button>
                            <button 
                                @click="viewpdf(item.id)"  class="btn btn-primary btn-sm rounded-circle bootom me-1" title="PDF Mov.">
                                <i class="fas fa-solid fa-file-pdf"></i>
                            </button>
                            <button 
                                @click="updateStateAnnular(item.id)" class="btn btn-primary btn-sm rounded-circle bootom" title="Anular Mov."
                                v-if="item.stock_destination_state == 1 && item.anulation_state == 0">
                                <i class="fas fa-times-circle"></i>
                            </button>
                          </div>
                        </td>
                    </tr>
                  
                  </tbody>
                </table>
              </div>

              <!--pag-->
              <div
                v-if="cpData.length > 0 && showTable"
                class="d-flex justify-content-center px-1 mb-4"
              >
                <nav aria-label="Page navigation example">
                  <ul class="pagination mb-1">
                    <li class="page-item">
                      <a
                        class="page-link page"
                        href="javascript:void(0)"
                        @click="backPage"
                        >Anterior</a
                      >
                    </li>
                    <li v-if="limitedStepPagination[0] !== 1" class="page-item">
                      <a
                        :class="selectPage === 1 ? 'page-link active' : 'page-link'"
                        href="javascript:void(0)"
                        @click="selectedPage(1)"
                        >1</a
                      >
                    </li>
                    <li v-if="limitedStepPagination[0] > 2" class="page-item disabled">
                      <span class="page-link">...</span>
                    </li>

                    <li
                      v-for="(item, index) in limitedStepPagination"
                      :key="index"
                      class="page-item"
                    >
                      <a
                        :class="selectPage === item ? 'page-link active' : 'page-link'"
                        href="javascript:void(0)"
                        @click="selectedPage(item)"
                        >{{ item }}
                      </a>
                    </li>
                    <li
                      v-if="
                        limitedStepPagination[limitedStepPagination.length - 1] <
                        stepPagination.length - 1
                      "
                      class="page-item disabled"
                    >
                      <span class="page-link">...</span>
                    </li>
                    <li
                      v-if="
                        limitedStepPagination[limitedStepPagination.length - 1] !==
                        stepPagination.length
                      "
                      class="page-item"
                    >
                      <a
                        :class="
                          selectPage === limitedStepPagination.length + 2
                            ? 'page-link active'
                            : 'page-link'
                        "
                        href="javascript:void(0)"
                        @click="selectedPage(stepPagination.length)"
                        >{{ stepPagination.length }}
                      </a>
                    </li>
                    <li class="page-item">
                      <a
                        class="page-link page"
                        href="javascript:void(0)"
                        @click="nextPage"
                        >Siguiente</a
                      >
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <cModalMovDetailVue
      :title="modalDeta.title"
      :boo_modal="modalDeta.boo_modal"
      :item="modalDeta.item"
      :id="modalDeta.id"
      @mtdClose="mtdCloseModal"
    />
    <SweetAlert :swal="swal" ref="SweetAlert" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
import cModalMovDetailVue from "@/components/Farmacia/Modals/cModalMovDetail.vue";

export default {
  name: "historialAlmacen-Pharmacy",
  components: {
    SweetAlert,
    cModalMovDetailVue
  },
  data() {
    return {
      swal: null,
      search: "",
      dataMarca: [],
      selectedMarca: "",
      dataProducto: [],
      selectedProducto: "",
      dataAlmacen: [],
      showTable: false,
      dataShow: [],
      page: 0,
      selectPage: 1,
      stepPagination: [],
      totalPagesToShow: 4,
      showPdf: false,
      filter: {
        init: null,
        end: null,
        almaOrigen: null,
        almaDestino: null,
      },
      dataAlmacenes: [],
      dataDestino: [],
      modalDeta: {
        title: "",
        item: [],
        boo_modal: false,
        id: null,
      },
      dateFilter: false
    };
  },
  created() {
    moment.locale("es");
    this.mtdAsignDate();
    this.mtdGetData();
    this.mtdGetAlmacen();
  },
  watch: {
    selectPage() {
      this.calculateData(7);
    },
    'filter.almaOrigen'(newAlmacen) {
        if (newAlmacen) {
           this.filter.almaDestino = null;
            const selectedAlmacen = this.dataAlmacenes.find(
                (almacen) => almacen.id === newAlmacen
            );
            if (selectedAlmacen && selectedAlmacen.destino) {
                //this.dataDestino = selectedAlmacen.destino;
                this.dataDestino = [{ name: 'TODOS', id: null }, ...selectedAlmacen.destino];
            } else {
               this.filter.almaDestino = null;
                this.dataDestino = [];
            }
        } else {
           this.filter.almaDestino = null;
            this.dataDestino = [];
        }
    },
  },
  computed: {
    cpData() {
      return this.dataShow;
    },

    limitedStepPagination() {
      const totalPages = this.stepPagination.length;
      const currentPage = this.selectPage;

      let startPage = 1;
      let endPage = totalPages;
      if (totalPages > this.totalPagesToShow) {
        const halfPagesToShow = Math.floor(this.totalPagesToShow / 2);

        if (currentPage > halfPagesToShow) {
          startPage = currentPage - halfPagesToShow;
          endPage = currentPage + halfPagesToShow - 1;

          if (endPage > totalPages) {
            endPage = totalPages;
            startPage = totalPages - this.totalPagesToShow + 1;
          }
        } else {
          endPage = this.totalPagesToShow;
        }
      }

      return Array.from(
        {
          length: endPage - startPage + 1,
        },
        (_, i) => startPage + i
      );
    },
  },
  methods: {
    ...mapActions(["get", "post"]),

    mtdAsignDate() {
      this.filter.end =
      moment().format("L").substr(6, 4) +
      "-" +
      moment().format("L").substr(3, 2) +
      "-" +
      moment().format("L").substr(0, 2);
      this.filter.init = this.filter.end;
    },

    handleSwitchChange() {
        this.dateFilter = !this.dateFilter;
        this.mtdAsignDate();
        this.mtdGetData();
    },
    
    mtdGetData: function () {
      this.post({
        url: this.$store.getters.get__url + "/Pharmacy/movement/mtdHistoryMov",
        token: this.$store.getters.get__token,
        params: {
          init: this.filter.init,
          end: this.filter.end,
          almaOrigen: this.filter.almaOrigen,
          almaDestino: this.filter.almaDestino,
          campu: this.$store.getters.get__campus,
          dateFilter: this.dateFilter
        },
      })
        .then((response) => {
          if (response.data.length === 0) {
            this.showTable = false;
            this.showPdf = false;
            this.noRecordsMessage = "No se encontraron resultados.";
            this.$refs.SweetAlert.showWarning("Sin Movimientos");
          } else {
            this.dataAlmacen = response.data;
            this.calculateData(7);
            this.showTable = true;
            this.showPdf = true;
            this.noRecordsMessage = "";
          }
        })
        .catch((errors) => {
          this.$refs.SweetAlert.showError(errors);
        });
    },

    mtdGetAlmacen: function () {
        this.get({
            url: this.$store.getters.get__url + "/Pharmacy/movement/almacen/"+ this.$store.getters.get__campus,
            token: this.$store.getters.get__token,
        }).then((response) => {
            //this.dataAlmacenes = response.data
            this.dataAlmacenes = [{ name: 'TODOS', id: null }, ...response.data];
        }).catch((error) => {
            this.$refs.SweetAlert.showError(error);
        });
    },

    calculateData(items) {
      if (!this.dataAlmacen || !this.dataAlmacen.length) {
        return (this.dataShow = []);
      }
      let filteredData = this.dataAlmacen;
      let indexInitial = this.selectPage;
      let totalPages = Math.ceil(filteredData.length / items);
      this.stepPagination = Array.from(
        {
          length: totalPages,
        },
        (_, index) => index + 1
      );
      let startIndex = (indexInitial - 1) * items;
      let endIndex = startIndex + (items - 1);
      this.dataShow = filteredData.slice(startIndex, endIndex + 1);
      this.count = this.count + 1;
    },

    viewpdf: function (id) {
      window.open(
        this.$store.getters.get__url +
          "/Pharmacy/movement/viewpdfHistMov/" +
          id,
        "_blank"
      );
    },

    viewDetail: function (item, detail) {
      this.modalDeta.title = 'Detalles de Movimiento: ' + item.correlative;
      this.modalDeta.id = item.id;
      this.modalDeta.item = detail;
      this.modalDeta.boo_modal = true;
    },

    mtdCloseModal: function () {
      this.modalDeta = {
        title: "",
        item: [],
        boo_modal: false,
        id: null,
      };
    },

    //Annular
    stateAnnular(item) {
      switch (item) {
        case 0:
          return "Activo";
        case 1:
          return "Pendiente Anulación";
        case 2:
          return "Anulado";
        case 3:
          return "Anulado Parcial";
        case 4:
          return "Anulación Rechazada";
        case 5:
          return "No se pudo Anular";
        default:
          return "-";
      }
    },

    badgeStyle(state) {
      const colors = {
        0: { background: "green", color: "white" }, // Verde
        1: { background: "blue", color: "white" }, // Azul
        2: { background: "yellow", color: "black" }, // Amarillo
        3: { background: "orange", color: "white" }, // Naranja
        4: { background: "red", color: "white" }, // Rojo
        5: { background: "lightblue", color: "black" }, // Celeste
        default: { background: "gray", color: "white" }, // Plomo
      };
      return {
        padding: "2px 5px",
        borderRadius: "5px",
        fontWeight: "bold",
        fontSize: "11px",
        display: "inline-block",
        ...colors[state] || colors.default,
      };
    },

    updateStateAnnular: function(id) {

      this.$refs.SweetAlert.showConfirmSimple2("¿Estás seguro de realizar Anulación de Movimiento?", "Se cambiara el estado a Pendiente Anulación", "warning", "Confirmar")
      .then((result) => {
          if (result.value) {
              this.mtdUpdateStateAnnular(id);
          }
      });
    },

    mtdUpdateStateAnnular: function(id) {
        this.get({
            url: this.$store.getters.get__url + "/Pharmacy/movement/updateStateAnnular/"+ id + "/" + 1,
            token: this.$store.getters.get__token,
        }).then((response) => {
          if(response.statusCode == 200) {
            this.$refs.SweetAlert.showSuccess("Estado de Anulacion Cambiado a Pendiente");
            this.mtdGetData();
          } else {
            this.$refs.SweetAlert.showError("Error");
          }
        }).catch((error) => {
            this.$refs.SweetAlert.showError(error);
        });
    },

    //Pag
    backPage() {
      this.selectPage = this.selectPage > 1 ? this.selectPage - 1 : 1;
    },
    nextPage() {
      this.selectPage =
        this.selectPage < this.stepPagination.length
          ? this.selectPage + 1
          : this.stepPagination.length;
    },
    selectedPage(page) {
      this.selectPage = page;
    },
    returnHome: function () {
      this.$emit("returnHome");
    },
  },
  filters: {
    formatDate(date) {
      return date != null ? moment(date).format("DD/MM/YYYY") : "-";
    },
    formatDateTime(dateTime) {
      return dateTime != null ? moment(dateTime).format("DD/MM/YYYY HH:mm") : "-";
    },
  },
};
</script>

<style scoped>
.custom-table th,
.custom-table td {
  font-size: 12px;
}

.table-container {
  overflow-x: auto;
  white-space: nowrap;
  scrollbar-width: thin;
  scrollbar-color: darkgray lightgray;
  padding-bottom: 10px;
}

.large-text {
  font-size: 9px;
}

.observation-column {
  max-width: 120px; 
  white-space: normal;
  word-wrap: break-word; 
}

.bootom {
  background-color: #900052 !important; 
  border: 0.5px solid #900052 !important;
}
</style>
